export const isSelectDisabled = ({ optionsGrouped, options, preSavedValue, disabled }) => {
  const hasOptions = !!(options && options.length);
  const hasOptionsGrouped = !!(optionsGrouped && Object.keys(optionsGrouped).length);

  return disabled || (!(hasOptionsGrouped || hasOptions) && !preSavedValue);
};
